import { safeInit } from "./core/init";
import { initEvents } from "./core/events";

import { initNav } from "./modules/nav";
import { initUI } from "./modules/ui";
import { handleScroll } from "./modules/scroll";
import { initEffects } from "./modules/effect";
import { initMisc } from "./modules/misc";
import { swiperInit } from "./modules/swiper";

document.addEventListener("DOMContentLoaded", () => {
	safeInit(initNav, "nav");
	safeInit(initUI, "ui");
	safeInit(initEffects, "effects");
	safeInit(initMisc, "misc");
	safeInit(swiperInit, "swiper");

	initEvents({
		onScroll: handleScroll
	});
});